import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ImageWebComponent } from '@resident-nx/web/ui';

@Component({
  standalone: true,
  selector: 'rs-web-tickets-no-catalogue',
  imports: [TranslateModule, ImageWebComponent],
  templateUrl: './tickets-no-catalogue.component.html',
  styleUrl: './tickets-no-catalogue.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TicketsNoCatalogueComponent {}
